import { AuthService } from '../services/AuthService';
import { api } from '../utils/api';

interface TicketFile {
  id: number;
  created_at: string;
}

export interface Ticket {
  id: number;
  created_at: string;
  ticket_file: TicketFile;
  deleted: boolean;
}

export interface TicketsResponse {
  response: TicketsResponseObj | null;
  meta: TicketsMeta;
}

export interface TicketsResponseObj {
  items: Ticket[];
  meta: TicketsResponseObjMeta;
}

export interface TicketsResponseObjMeta {
  total: number;
}

export interface IOrderTicketFileResponse {
  response: string;
  meta: TicketsMeta;
}

export interface TicketsMeta {
  error: string | null | BackendError;
  datetime: number;
}

export interface BackendError {
  code: number;
  message: string;
}

export const getOrderTickets = async (
  orderUuid: string,
  signal?: AbortSignal
): Promise<TicketsResponse> => {
  try {
    const headers: Record<string, string> = {};
    if (AuthService.authToken !== null) {
      headers.Authorization = `Bearer ${AuthService.authToken}`;
    } else {
      throw new Error('Пользователь не авторизирован');
    }

    const response = await api.get<TicketsResponse>(
      `/admin/order-tickets/${orderUuid}`,
      { headers, signal }
    );

    if (response.data?.meta?.error != null) {
      if (typeof response.data.meta.error === 'string') {
        throw new Error(response.data.meta.error);
      }
      if (
        typeof response.data.meta.error === 'object' &&
        'message' in response.data.meta.error
      ) {
        throw new Error(response.data.meta.error.message);
      }
    }

    return response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    throw error;
  }
};

// export const getOrderTicketFile = async (
//   orderId: string,
//   fileId: string
// ): Promise<IOrderTicketFileResponse | undefined> => {
//   try {
//     const myHeaders = new Headers();
//     if (AuthService.authToken !== null) {
//       myHeaders.append('Authorization', `Bearer ${AuthService.authToken}`);
//     } else {
//       toast('Пользователь не авторизирован', { type: 'error' });
//       throw new Error('Пользователь не авторизирован');
//     }

//     const requestOptions = {
//       method: 'GET',
//       headers: myHeaders
//     };

//     const res = await fetch(
//       `${import.meta.env.VITE_API_URL}/api/admin/order-ticket/${orderId}/${fileId}`,
//       requestOptions
//     );

//     if (!res.ok) {
//       throw new Error('Не получилось получить данные о чеке заказа');
//     }

//     if (res.status === 400) {
//       const errorResponse: TicketsMeta = await res.json();
//       if (errorResponse.error !== null && typeof errorResponse.error === 'string') {
//         toast.error(errorResponse.error);
//         throw new Error(errorResponse.error);
//       }

//       if (errorResponse.error !== null && typeof errorResponse.error === 'object' && 'message' in errorResponse.error) {
//         toast.error(errorResponse.error.message);
//         throw new Error(errorResponse.error.message);
//       }
//     }

//     const data: IOrderTicketFileResponse = await res.json();
//     return data;
//   } catch (error) {
//     console.error(error); // eslint-disable-line
//   }
// };

export const getOrderTicketFile = async (
  orderId: string,
  fileId: string
): Promise<IOrderTicketFileResponse> => {
  try {
    const headers: Record<string, string> = {};
    if (AuthService.authToken !== null) {
      headers.Authorization = `Bearer ${AuthService.authToken}`;
    } else {
      throw new Error('Пользователь не авторизирован');
    }

    const response = await api.get<IOrderTicketFileResponse>(
      `/admin/order-ticket/${orderId}/${fileId}`,
      { headers }
    );

    if (response.data?.meta?.error != null) {
      const error = response.data.meta.error;
      throw new Error(typeof error === 'string' ? error : error.message);
    }

    return response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    throw error;
  }
};
